"use client";

import { AgeType } from "libs/cat-calculations/src/lib/cat-calculations.types";
import { RecipesForCatResponse } from "@forms/schema";
import { IRecipeItem } from "libs/state/src/lib/stores/signupFlow/types";
import {
  getFreshTrialRecipes,
  RecipeCount,
} from "libs/recipes/src/lib/recipes";
import { FRESH_PRICING_PLAN_DETAILS } from "@./types/subscriptions/constants";

import { Allergen, PricingPlan } from "@/primary-models";

import { useSignupFlowStore } from "./useSignUpFlowStore";

/**
 * Returns trial recipes based on the user's plan (7 or 14 recipes).
 * Reads planType from store to determine recipe count.
 */
export const useFreshTrialRecipes = () => {
  const planType = useSignupFlowStore((state) => state.subscription.trial?.planType);
  const trialPlan = planType ?? PricingPlan.TRIAL;
  const isTestVariant = trialPlan === PricingPlan.TRIAL_WEEK;
  const recipeCount = FRESH_PRICING_PLAN_DETAILS[trialPlan].quantity as RecipeCount;

  const getRecipes = (
    allergies: Allergen[],
    lifeStage: AgeType,
    recipeItems?: IRecipeItem[],
  ): RecipesForCatResponse => getFreshTrialRecipes(allergies, lifeStage, recipeItems, recipeCount);

  return {
    getRecipes,
    recipeCount,
    isTestVariant,
  };
};
